import { ChangeDetectorRef, ElementRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Logger } from 'src/app/core/logger';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { WidgetsFormModel } from 'src/app/models/widgets/widgets-form.model';
import { FormTypeModel } from 'src/app/models/api/form-type.model';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormService } from 'src/app/services/api/form.service';
import { Config } from 'src/app/config';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { EditFormsDialogueComponent } from '../../dialogs/edit-approve-forms/edit-form-dialogue.component';
import { FormStatesEnum } from 'src/app/enums/form-states/form-states.enum';
import { DownloadService } from 'src/app/services/api/download.service';

@Component({
  selector: 'appMetadataForm',
  templateUrl: './metadata-form.component.html',
  styleUrls: ['./metadata-form.component.scss']
})
export class MetadataFormComponent implements OnInit {
  @Input() data: WidgetsFormModel = new WidgetsFormModel();
  linkPreview = Config.CONSTANTS.routePreview;

  @ViewChild('createFormTemplate') templateRefCreateForm?: ElementRef;
  @ViewChild('createFormTemplateConfirmation') templateRefCreateFormConfirmation?: ElementRef;
  
  public formTypes$?: Observable<FormTypeModel[]>;
  public bsModalRef!: BsModalRef;
  showEditFormBtn:boolean = false;

    // Modal Dialog
    modalRefConf: BsModalRef = new BsModalRef();

  constructor(private widgetsService: WidgetsService,
    private formService: FormService,
    public cd: ChangeDetectorRef,
    private router: Router,
    private toastr: ToastrService,
    private logger: Logger,
    private modalService: BsModalService,
    private downloadService: DownloadService) {  
  }

  ngOnInit(): void {
    let statusId = this.widgetsService.getLayoutRoot().version?.StatusId ;  
    if(statusId === FormStatesEnum.Published ||  statusId  == FormStatesEnum.Approved ){
      this.showEditFormBtn = true;
    }   
    this.formTypes$ = this.formService.getFormTypes();
    //   .pipe(tap((types : FormTypeModel[]) => {
    //   this.logger.log("Tap FormTypes "+JSON.stringify(types));
    // }));
  }

  getFormType(types: FormTypeModel[]) {
    if (this.data && this.data.data && this.data.data.formTypeId && types) {
      const myType : FormTypeModel | undefined = types.find(x => x.Id === this.data.data.formTypeId);
      if (myType !== undefined) {
        return(myType.Name);
      }
    }
    return('Undefined');
  }

  onSelect($event:any, id:any, types:FormTypeModel[]) {
    // const type = $event.target[$event.target.selectedIndex].dataset.type;
    // if (types && id && $event.isUserInput) {
    //   const myType : FormTypeModel | undefined = types.find(x => x.Id === id)
    //   if (myType !== undefined)
    //     this.formType = myType.Name;      
    // }
  }
  previewNavigate($event:any){
    this.router.navigate([Config.CONSTANTS.routePreview], {
      queryParams: { id: this.data.dbId }
    });
  }
  onHide($event:any) {
  }

  onRefreshFields(): void {
  }

  createFormConfirmation() {
    this.modalRefConf = this.modalService.show(this.templateRefCreateFormConfirmation, {
      class: 'custom-create-form',
    });
  }

  createForm() {
    this.modalRefConf.hide();
    this.modalRefConf = this.modalService.show(this.templateRefCreateForm, {
      class: 'custom-create-form',
    });
  }


  createNewFormVersion() {

    this.formService.addNewVersion(this.data.dbId ?? 0, this.data.serviceCode).subscribe(res => {
      this.toastr.success("New version created" + res + "...");
      /*this.router.navigate([Config.CONSTANTS.routeBuilder], {
      queryParams: { id: this.data.dbId },
      });*/
    setTimeout(() => { window.location.reload(); }, 1800);


      this.modalRefConf.hide();
    },(failure) => {
      this.logger.log(failure.message);
      this.toastr.error("Error while saving the data please try again later.");
    });
  }

  onDebug() {
    this.logger.log("Metadata Form");
  } 
  public openDialog() {
    /* this is how we open a Modal Component from another component 
    this.bsModalRef = this.modalService.show(EditFormsDialogueComponent, {
      class: 'custom-create-form',
    });*/
    this.createFormConfirmation();
  }

  public downloadQuestions() {
    
    const fileName = `${new Date().toLocaleDateString('en-US')}_${this.data.name}`;
    
    const questionsWigets = this.formService.extractQuestionsFromFormWidget(this.data);

    const data = JSON.stringify(questionsWigets, null, 2);
    
    const blob = new Blob([data], { type: 'application/json' });

    this.downloadService.downloadBlobAsFile(blob, fileName, "json").copyTextToClipboard(data);

  }
}
